module.exports = __webpack_public_path__ + "img/file_format_csv.f93e93e0.png";